// Add event listeners to each .poi-right element
document.querySelectorAll('.intro-with-circle-tab .poi-right').forEach(function(element) {
    element.addEventListener('click', function(event) {
        // Prevent click event from bubbling up to the document when clicking inside poi-right
        event.stopPropagation();

        // Remove 'active' class from all other poi-right elements
        document.querySelectorAll('.intro-with-circle-tab .poi-right').forEach(function(el) {
            el.classList.remove('active');
        });

        // Add 'active' class to the clicked element
        this.classList.toggle('active');
    });
});

// Add event listener to the document to handle clicks outside of .poi-right
document.addEventListener('click', function() {
    // Remove 'active' class from all poi-right elements when clicking outside
    document.querySelectorAll('.intro-with-circle-tab .poi-right').forEach(function(el) {
        el.classList.remove('active');
    });
});
